var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgLockCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM16.8906 19.25C16.8906 19.6875 16.5352 20.0156 16.125 20.0156C15.6875 20.0156 15.3594 19.6875 15.3594 19.25V17.5C15.3594 17.0898 15.6875 16.7344 16.125 16.7344C16.5352 16.7344 16.8906 17.0898 16.8906 17.5V19.25ZM20.9375 14C21.6484 14 22.25 14.6016 22.25 15.3125V21.4375C22.25 22.1758 21.6484 22.75 20.9375 22.75H11.3125C10.5742 22.75 10 22.1758 10 21.4375V15.3125C10 14.6016 10.5742 14 11.3125 14H12.1875V12.6875C12.1875 10.5273 13.9375 8.75 16.125 8.75C18.3125 8.77734 20.0625 10.5547 20.0625 12.7422V14H20.9375ZM13.5 12.6875V14H18.75V12.6875C18.75 11.2656 17.5469 10.0625 16.125 10.0625C14.6758 10.0625 13.5 11.2656 13.5 12.6875ZM20.9375 21.4375V15.3125H11.3125V21.4375H20.9375Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLockCircled);
export default __webpack_public_path__ + "static/media/img_lock-circled.988c2a0e3176ab735139fb07cf723302.svg";
export { ForwardRef as ReactComponent };